<template>
  <div class="question-form">
    <transition-group name="question-fade" tag="div">
    <div
      v-for="q in questions"
      :key="q.key"
      class="question-item mb-4"
    >
      <div class="question-label overline mb-2">{{ q.label }}</div>

      <!-- select: button group -->
      <div v-if="q.type === 'select' && q.options && q.options.length && !freeTextKeys[q.key]" class="d-flex">
        <v-btn-toggle
          :value="answers[q.key]"
          @change="val => $emit('answer', q.key, val)"
          mandatory
          dense
          class="flex-wrap"
        >
          <v-btn
            v-for="opt in q.options"
            :key="opt"
            :value="opt"
            small
            outlined
            class="text-none"
          >
            {{ opt }}
          </v-btn>
        </v-btn-toggle>
        <v-btn
          small
          outlined
          flat
          text
          class="pencil-btn"
          @click="$set(freeTextKeys, q.key, true); $emit('answer', q.key, '')"
        >
          <v-icon small>mdi-pencil</v-icon>
        </v-btn>
      </div>

      <!-- select: free-text override -->
      <v-text-field
        v-else-if="q.type === 'select' && freeTextKeys[q.key]"
        :value="answers[q.key]"
        @input="val => $emit('answer', q.key, val)"
        append-icon="mdi-close"
        @click:append="$set(freeTextKeys, q.key, false); $emit('answer', q.key, null)"
        dense
        outlined
        hide-details
        style="max-width: 400px"
      />

      <!-- non-select -->
      <v-text-field
        v-else
        :value="answers[q.key] || ''"
        @input="val => $emit('answer', q.key, val)"
        :suffix="q.unit || undefined"
        dense
        outlined
        hide-details
        style="max-width: 200px"
      />
    </div>
    </transition-group>

    <div v-if="questionsReady" class="question-item mt-6">
      <div class="question-label overline mb-2">Rajoutez d'autres précisions sur le chantier</div>
      <v-textarea
        :value="answers['extra_details'] || ''"
        @input="val => $emit('answer', 'extra_details', val)"
        outlined
        dense
        hide-details
        rows="3"
        auto-grow
        style="max-width: 600px"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'QuestionForm',
  data() {
    return {
      freeTextKeys: {},
    }
  },
  props: {
    questions: {
      type: Array,
      default: () => [],
    },
    answers: {
      type: Object,
      default: () => ({}),
    },
    questionsReady: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.question-label {
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 0.08em;
  color: var(--app-question-label, var(--v-secondary-base));
}

.question-fade-enter-active {
  transition: opacity 0.35s ease, transform 0.35s ease;
}
.question-fade-enter {
  opacity: 0;
  transform: translateY(10px);
}
</style>
